module.exports = __webpack_public_path__ + "static/img/MV8.0909ab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV8.jpg
// module id = sgb2
// module chunks = 0